import React from 'react';
import { useSafeArea } from 'react-native-safe-area-context';
import { useNavigation } from '@react-navigation/native';

import LogoTitle from '@src/components/LogoTitle';

import { CloseIcon, Container, Head, Spacer } from './styled';
import { Props } from './types';

const Header: React.FC<{ onClosePress?(): void }> = ({ onClosePress }) => {
  return (
    <Head>
      <CloseIcon onPress={onClosePress} icon="times" />
      <LogoTitle />
      <Spacer />
    </Head>
  );
};

const Component: React.FC<Props> = ({ children }) => {
  const insets = useSafeArea();
  const navigation = useNavigation();

  const onClosePressHandler = React.useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      console.warn('cannot go back from here!');
      navigation.navigate('Home');
    }
  }, [navigation]);

  return (
    <Container insets={insets}>
      <Header onClosePress={onClosePressHandler} />
      {children}
    </Container>
  );
};

export default Component;
